import { render } from "./AgentCreateTicket.vue?vue&type=template&id=289b7fd5"
import script from "./AgentCreateTicket.vue?vue&type=script&lang=js"
export * from "./AgentCreateTicket.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__